export default __webpack_public_path__ + "static/media/ic_plus.f267f881.svg";